import { ConnectProto } from "@racoon/api";
import { toDateLike } from "@racoon/lib";

const isLive = (contract: ConnectProto.Contract, now: Date): boolean => {
  if (contract.status !== ConnectProto.ContractStatus.ACTIVE) return false;
  const end = toDateLike(contract.endAt);
  return !end || end > now;
};

const startTime = (contract: ConnectProto.Contract): number =>
  toDateLike(contract.startAt)?.getTime() ?? 0;

/**
 * The contract each customer row shows, by target organization id: the one the status
 * badge reads first — an ACTIVE contract whose end has not passed — then the latest start,
 * then the newest id. A customer often holds several contracts with the provider and its
 * children; the cell names one, the card lists them all.
 */
export const contractsByCounterparty = (
  contracts: readonly ConnectProto.Contract[],
  now: Date = new Date(),
): Map<string, ConnectProto.Contract> => {
  const picked = new Map<string, ConnectProto.Contract>();
  for (const contract of contracts) {
    const key = String(contract.targetOrganizationId);
    const current = picked.get(key);
    if (!current || outranks(contract, current, now)) picked.set(key, contract);
  }
  return picked;
};

const outranks = (a: ConnectProto.Contract, b: ConnectProto.Contract, now: Date): boolean => {
  const live = Number(isLive(a, now)) - Number(isLive(b, now));
  if (live !== 0) return live > 0;
  const start = startTime(a) - startTime(b);
  if (start !== 0) return start > 0;
  return a.id > b.id;
};
